"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$body", function ($document) {
  return $document.find("body");
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/$body.js
// module id = 2738
// module chunks = 13